import { Circ, Expo, TimelineLite, TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as PIXI from "pixi.js";
import {Ease} from "../core/Animatable";
import {Container} from "../core/Container";
import {array} from "../core/Reflection";
import {Sprite} from "../core/Sprite";
import { Button } from "../gameobjects/Button";

import { random, shuffle } from "html-living-framework/lib/Utils/ArrayUtils";
import { sendToFront } from "html-living-framework/lib/Utils/PixiUtils";
import { Application } from "../Application";
import * as VO from "../data/VO";
import { CaptionManager } from "../managers/CaptionManager";
import { AbstractBadgePopup } from "./AbstractBadgePopup";

export class PlantingBadgePopup extends AbstractBadgePopup {

    public static readonly NAME = "PlantingBadgePopup";
    public readonly badgeVO = [VO.BADGE04, VO.BADGE04B];

    public init(pSize: PIXI.Point) {
        super.init(pSize);
        this.abby.visible = true;
    }
    public AnimateIn(pCallback: () => void) {
        super.AnimateIn(pCallback);
        shuffle(AbstractBadgePopup.stickers.planterparty);
        const nextSticker: number | undefined = AbstractBadgePopup.stickers.planterparty.pop();
        AbstractBadgePopup.latestSticker.planterparty = nextSticker;
        if (nextSticker !== undefined) {
            this.planterpartySticker[nextSticker].visible = true;
            sendToFront(this.planterpartySticker[nextSticker]);
            TweenLite.from(this.planterpartySticker[nextSticker], 0.5, {pixi: {scale: 1.5, alpha: 0}});
        }
    }
}
